export default __webpack_public_path__ + "static/media/SoyaBean.23114348.jpg";